var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1818 10.0002C18.1818 14.5189 14.5187 18.182 10 18.182C5.48131 18.182 1.81818 14.5189 1.81818 10.0002C1.81818 5.48149 5.48131 1.81836 10 1.81836C14.5187 1.81836 18.1818 5.48149 18.1818 10.0002Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63636 6.97931C8.96955 6.60184 9.457 6.36377 10 6.36377C11.0042 6.36377 11.8182 7.1778 11.8182 8.18195C11.8182 9.03077 11.2365 9.74377 10.4499 9.94404C10.2066 10.006 10 10.2037 10 10.4547V10.9092",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.6362H10.0087",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenter);
export default __webpack_public_path__ + "static/media/help-center.e8ae274a0ed3cdb584a2941651810523.svg";
export { ForwardRef as ReactComponent };